export default {
  'pageTitle.title': 'Examod: Dijital Sınav ve Değerlendirme Platformu',
};
